define("shared/helpers/get-attachment-url", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f
  /**
   * Returns the image url for the given attachment and variant.
   *
   * Priorities:
   * - attachment.previewUrl (only available if user just uploaded the image)
   * - attachment.variants[variant]
   * - attachment.variants.original.url
   *
   * @param attachment The attachment to get the url for.
   * @param variant The variant to get the url for.
   *
   */
  function getAttachmentUrl(_ref, _ref2) {
    let [attachment] = _ref;
    let {
      variant
    } = _ref2;
    if (attachment.previewUrl) {
      return attachment.previewUrl;
    }
    if (attachment.variants) {
      if (attachment.variants[variant] && attachment.variants[variant].processed) {
        return attachment.variants[variant].url;
      }
      if (attachment.variants.original) {
        return attachment.variants.original.url;
      }
    }
    return '';
  }
  var _default = _exports.default = (0, _helper.helper)(getAttachmentUrl);
});